var React = require('react');

function IconExclamationInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11,14 C10.4477153,14 10,13.5025386 10,12.8888889 L10,5.11111111 C10,4.49746139 10.4477153,4 11,4 C11.5522847,4 12,4.49746139 12,5.11111111 L12,12.8888889 C12,13.5025386 11.5522847,14 11,14 Z","key":0}),React.createElement("circle",{"cx":"11","cy":"17","r":"1","key":1}),React.createElement("path",{"d":"M11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 Z M11,2.2 C6.1398942,2.2 2.2,6.1398942 2.2,11 C2.2,15.8601058 6.1398942,19.8 11,19.8 C15.8601058,19.8 19.8,15.8601058 19.8,11 C19.8,8.66609489 18.8728598,6.42778046 17.2225397,4.77746033 C15.5722195,3.1271402 13.3339051,2.2 11,2.2 Z","key":2})]);
}

IconExclamationInline.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = IconExclamationInline;

IconExclamationInline.default = IconExclamationInline;
